import React from 'react';

function QbankBreak(props) {
  return (
    <div className="qbank-break" />
  );
}

export default QbankBreak;



// WEBPACK FOOTER //
// ./src/components/QbankBreak.js